

.icon
{
  height: 1.5em;
  display: inline-block;
  margin-right: .5em;
}